import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../constants'
import {
	RetentionAnalyticsService,
	CohortRetentionQuery,
	CohortRetentionResponse,
} from '../services'

export const useQueryGetCohortRetention = (
	query?: CohortRetentionQuery,
	enabled = true,
) => {
	return useQuery<CohortRetentionResponse>({
		queryKey: QUERY_KEYS.RETENTION_ANALYTICS.COHORT(query),
		queryFn: () => RetentionAnalyticsService.getCohortRetention(query),
		enabled,
	})
}
